<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-0">
            회사ID
        </label>
        <div class="col-md-4 position-relative">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm"
                    formControlName="companyId"
                    readonly>
            </div>
        </div>

        <label class="col-md-2 mb-0">
            업체코드
        </label>
        <div class="col-md-4 position-relative">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm"
                    formControlName="ccd"
                    maxlength="5">
            </div>
        </div>
    </div>

    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-0">
            업체명
        </label>
        <div class="col-md-4 position-relative">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm"
                    [ngClass]="{'is-invalid':submitted && f.companyNm.errors}"
                    formControlName="companyNm">
                <div class="invalid-tooltip" *ngIf="submitted && f.companyNm.errors">
                    <div *ngIf="f.companyNm.errors.required">필수 입력 항목 입니다</div>
                </div>
            </div>
        </div>

        <label class="col-md-2 mb-0">
            대표자성명
        </label>
        <div class="col-md-4 position-relative">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm"
                    formControlName="ownerNm">
            </div>
        </div>
    </div>

    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-0">
            법인등록번호
        </label>
        <div class="col-md-4 position-relative">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm"
                    formControlName="tid">
            </div>
        </div>

        <label class="col-md-2 mb-0">
            사업자등록번호
        </label>
        <div class="col-md-4 position-relative">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm"
                    [ngClass]="{'is-invalid':submitted && f.dtgEid.errors}"
                    formControlName="dtgEid">
                <div class="invalid-tooltip" *ngIf="submitted && f.dtgEid.errors">
                    <div *ngIf="f.dtgEid.errors.required">필수 입력 항목 입니다</div>
                </div>
            </div>
        </div>
    </div>

    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-0">
            면허정보
        </label>
        <div class="col-md-10 position-relative">
            <div class="input-group input-group-sm">
                <div class="form-check form-check-inline" formArrayName="listCompanyLcs"
                    *ngFor="let companyLcsInfo of f2.controls;let idx = index;">
                    <label class="mb-0" [formGroupName]="idx">
                        <input class="" type="checkbox" formControlName="useYn"
                            (change)="changeCompanyLcs($event,idx)">
                        {{companyLcsInfo.get("dtgCarTypeNm").value}}
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-0">
            주소
        </label>
        <div class="col-md-10 position-relative">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm"
                    formControlName="addr1">
            </div>
        </div>
    </div>

    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-0">
            상세주소
        </label>
        <div class="col-md-6 position-relative">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm"
                    formControlName="addr2">
            </div>
        </div>

        <label class="col-md-2 mb-0">
            우편번호
        </label>
        <div class="col-md-2 position-relative">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm"
                    formControlName="zipCode">
            </div>
        </div>
    </div>

    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-0">
            노선수
        </label>
        <div class="col-md-2 position-relative">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control form-control-sm"
                    min="0"
                    formControlName="cntDrivePath">
            </div>
        </div>
    </div>

    <hr>

    <ng-container *ngIf="f2.controls">
        <div formArrayName="listCompanyLcs"
            *ngFor="let companyLcsInfo of f2.controls;let idx = index;">
            <ng-container *ngIf="companyLcsInfo.get('useYn').value === true" [formGroupName]="idx">
                <div class="form-group row align-items-center">
                    <label class="col-md-2 mb-0">
                        {{companyLcsInfo.get("dtgCarTypeNm").value}}
                    </label>
                    <label class="col-md-2 mb-0">
                        재직운전자수
                    </label>
                    <div class="col-md-1 position-relative">
                        <div class="input-group input-group-sm">
                            <input type="number" class="form-control form-control-sm"
                                min="0"
                                formControlName="cntDriverLcs"
                                (change)="changeCntDriverLcs($event,idx)">
                        </div>
                    </div>

                    <label class="col-md-2 mb-0">
                        면허대수
                    </label>
                    <div class="col-md-1 position-relative">
                        <div class="input-group input-group-sm">
                            <input type="number" class="form-control form-control-sm"
                                min="0"
                                formControlName="cntCarLcs"
                                (change)="changeCntCarLcs($event,idx)">
                        </div>
                    </div>

                    <label class="col-md-2 mb-0">
                        보유대수
                    </label>
                    <div class="col-md-1 position-relative">
                        <div class="input-group input-group-sm">
                            <input type="number" class="form-control form-control-sm"
                                min="0"
                                formControlName="cntCar"
                                (change)="changeCntCar($event,idx)">
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-0">
            계
        </label>
        <label class="col-md-2 mb-0">
            재직운전자수
        </label>
        <div class="col-md-1 position-relative">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control form-control-sm"
                    min="0"
                    formControlName="cntDriverLcs"
                    readonly>
            </div>
        </div>

        <label class="col-md-2 mb-0">
            면허대수
        </label>
        <div class="col-md-1 position-relative">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control form-control-sm"
                    min="0"
                    formControlName="cntCarLcs"
                    readonly>
            </div>
        </div>

        <label class="col-md-2 mb-0">
            보유대수
        </label>
        <div class="col-md-1 position-relative">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control form-control-sm"
                    min="0"
                    formControlName="cntCar"
                    readonly>
            </div>
        </div>
    </div>

    <hr>

    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-0">
            E-Tas ID
        </label>
        <div class="col-md-4 position-relative">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm"
                    formControlName="etasId">
            </div>
        </div>

        <label class="col-md-2 mb-0">
            E-Tas 비번
        </label>
        <div class="col-md-4 position-relative">
            <div class="input-group input-group-sm">
                <input type="password" class="form-control form-control-sm"
                    formControlName="etasPw">
                <div class="input-group-append">
                    <button type="button" class="btn btn-sm btn-outline-warning"
                        (click)="clickEtasPwReset()">
                        <i class="mdi mdi-account-key"></i>
                        <span class="ml-1">재설정</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="form-group row align-items-center">
        <div class="col text-right position-relative">
            <button type="button"
                class="btn btn-outline-success btn-sm"
                (click)="clickSave()">
                <i class="mdi mdi-content-save"></i>
                <span class="ml-1">
                    저장
                </span>
            </button>
        </div>
    </div>
</form>

<ng-template #modalEtasLoginPw let-modalObjEtasPw>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header py-2 bg-dark text-light">
                <h5 class="modal-title">E-Tas 비번 변경</h5>
            </div>
            <div class="modal-body">
                변경 되었습니다
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-success btn-sm"
                    (click)="modalObjEtasPw.close('cancel')">
                    <i class="mdi mdi-content-save"></i>
                    <span class="ml-1">
                        확인
                    </span>
                </button>
            </div>
        </div>
    </div>
</ng-template>